import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '../config/app-config';
import { DebugRoleService } from '../auth/debug-role.service';

/**
 * Attaches the Development-only `X-Debug-Role` / `X-Debug-Active` headers to API requests when a local
 * role impersonation is selected (localhost only). No effect in deployed builds.
 */
export const debugRoleInterceptor: HttpInterceptorFn = (req, next) => {
  const debug = inject(DebugRoleService);
  const config = inject(APP_CONFIG);
  if (!debug.enabled || !req.url.startsWith(config.apiBaseUrl)) {
    return next(req);
  }
  const headers = debug.headers();
  if (!headers) {
    return next(req);
  }
  return next(
    req.clone({ setHeaders: { 'X-Debug-Role': headers.role, 'X-Debug-Active': headers.active } }),
  );
};
